function addStartShoppingButtonInWishlist() {
    // Check if .wishlistajaxLoad is empty (for wishlist page)
    const wishlistLoad = document.querySelector(".wishlistajaxLoad");
    const wishlistNoItem = document.querySelector(".wishlistnoitem p"); // Check for .wishlistnoitem in the modal
    
    if (wishlistLoad && wishlistLoad.innerHTML.trim() === "") {
        // Check if the button already exists
        if (!document.querySelector(".start-shopping-button")) {
            // Create the new button
            const startShoppingButton = document.createElement("button");
            startShoppingButton.type = "button";
            startShoppingButton.name = "start-shopping";
            startShoppingButton.className = "product-form__submit button button--full-width button--primary-yellow start-shopping-button"; // Apply the same classes as the "Add to cart" button
            startShoppingButton.innerHTML = "<span>Start Shopping</span>";

            // Add click event to navigate to the shopping page
            startShoppingButton.addEventListener("click", function() {
                window.location.href = "https://lictricibikis.com/collections/shop-all-lectric-ebikes-products";
            });

            // Insert the button AFTER the wishlist content
            wishlistLoad.parentElement.appendChild(startShoppingButton);
        }
    }

    // Check if .wishlistnoitem exists (for modal)
    if (wishlistNoItem && wishlistNoItem.textContent.includes("No wishes yet")) {
        // Check if the button already exists
        if (!document.querySelector(".start-shopping-button")) {
            // Create the new button
            const startShoppingButton = document.createElement("button");
            startShoppingButton.type = "button";
            startShoppingButton.name = "start-shopping";
            startShoppingButton.className = "product-form__submit button button--full-width button--primary-yellow start-shopping-button";
            startShoppingButton.innerHTML = "<span>Start Shopping</span>";

            // Add click event to navigate to the shopping page
            startShoppingButton.addEventListener("click", function() {
                window.location.href = "https://lictricibikis.com/collections/shop-all-lectric-ebikes-products";
            });

            // Insert the button AFTER the "No wishes yet" message
            wishlistNoItem.parentElement.appendChild(startShoppingButton);
        }
    }
}

// Function to observe changes in the DOM and check for modal appearance
function observeWishlistModal() {
    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Check if the modal with id "sewp-engine-popupinr" appears
                const modal = document.getElementById("sewp-engine-popupinr");
                if (modal && modal.style.display !== "none") {
                    // If modal appears, run the same logic for empty wishlist
                    addStartShoppingButtonInWishlist();
                }
            }
        }
    });

    // Observe changes in the body
    observer.observe(document.body, { childList: true, subtree: true });

    // Extra: Initial check if modal is already visible on page load
    const modalCheckOnLoad = document.getElementById("sewp-engine-popupinr");
    if (modalCheckOnLoad && modalCheckOnLoad.style.display !== "none") {
        addStartShoppingButtonInWishlist();
    }
}

// Add an event listener to the 'wishlist-page-widget' link
const wishlistLink = document.querySelector('.wishlist-page-widget');
if (wishlistLink) {
    wishlistLink.addEventListener('click', function() {
        // When the link is clicked, start observing for modal and wishlist changes
        observeWishlistModal();
    });
}
